export default {
  version: "0.01",
  base: process.env.VUE_APP_BASE_API,
  uploadUrl:'https://www.caimishu.top',
  isDebug: true, //是否为调试状态
  onePageNum: 5, //分页默认条数
};
